import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { storage, db } from '../../firebase';
import firebase from 'firebase';
import './ImageUpload.css';

function ImageUpload({ userName }) {
    const [caption, setCaption] = useState('');
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);

    const handleChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    }

    const handleUpload = () => {
        // image.name is the file name with which it is passed to the database
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                // Progress function...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                setProgress(progress);
            },
            (error) => {
                // Error function
                console.log(error);
                alert(error.message);
            },
            // Final part when upload completes
            () => {
                // Complete function
                storage.ref('images').child(image.name).getDownloadURL().then(url => {
                    db.collection('posts').add({
                        // Using server timestamp which in this case is generated by server firebase to load the posts according to the time with the recent coming at the top
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption: caption,
                        imageUrl: url,
                        userName: userName
                    });

                    setProgress(0);
                    setCaption('');
                    setImage(null);

                });
            }
        )
    }

    return (
        <div className='imageUpload'>
            {/* Progress bar */}
            <progress className='imageUpload__progress' value={progress} max='100' />

            {/* Caption Input */}
            <input className='imageUpload__inputCaption' type="text" placeholder='Enter a caption...' value={caption} onChange={(event) => setCaption(event.target.value)} />

            {/* File picker */}
            <input type="file" onChange={handleChange} />
            <Button style={{ cursor: 'pointer' }} disabled={!image} className='imageupload__button' onClick={handleUpload}>Upload</Button>
            {/* Post Button */}
        </div>
    )
}

export default ImageUpload
